import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTimeClockCircle = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	id: "time-clock-circle_icon",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M12 0a12 12 0 1 0 12 12A12.013 12.013 0 0 0 12 0m5.2 17.221a1.016 1.016 0 0 1-1.413.062l-4.959-4.546A1 1 0 0 1 10.5 12V6.5a1 1 0 0 1 2 0v5.06l4.634 4.248a1 1 0 0 1 .066 1.414Z" })
});
export { SvgTimeClockCircle as ReactComponent };
